export default {
  'pages.404.subTitle': 'Maaf, halaman yang Anda kunjungi tidak ada.',
  'pages.404.buttonText': 'Kembali ke Beranda',
};
